module.exports = __webpack_public_path__ + "img/fan-made-video.05a382f0.jpg";